import { type EditorLine, isBlankLine } from './line_rules';

/** Media as the step editor tracks it. */
export type StepMediaState =
   | { type: 'image'; imageids: number[] }
   | { type: 'object'; objectid: number | null };

export type StepPayload = {
   title: string;
   lines: { text: string; bullet: string; level: number }[];
   media: { type: 'image'; data: number[] } | { type: 'object'; data: number | null };
   orderby?: number;
};

/**
 * The step save body the step endpoint expects: title, `{text, bullet,
 * level}` per line, and media as imageids or an objectid. `orderby` only
 * rides along when creating a new step.
 *
 * Blank lines are dropped here, so clicking Save silently deletes an empty
 * line instead of complaining about it. A step with no text at all (e.g.
 * image-only) saves with zero lines.
 */
export function buildStepPayload(args: {
   title: string;
   lines: EditorLine[];
   media: StepMediaState;
   orderby?: number;
}): StepPayload {
   const contentLines = args.lines.filter(line => !isBlankLine(line));
   const payload: StepPayload = {
      title: args.title,
      lines: contentLines.map(line => ({
         text: line.text,
         bullet: line.bullet,
         level: line.level,
      })),
      media:
         args.media.type === 'image'
            ? { type: 'image', data: args.media.imageids }
            : { type: 'object', data: args.media.objectid },
   };

   if (args.orderby !== undefined) {
      payload.orderby = args.orderby;
   }

   return payload;
}
